export enum Toast { 
  SUCCESS = 'Success!',
  ERROR = 'Error!',
  WARNING = 'Warning!'
}

export enum ToastVariant { 
  SUCCESS = 'success',
  ERROR = 'destructive',
  WARNING = 'warning'
}
